import { toPoint } from "mgrs";
import { SiteAnchor } from "../models/SiteAnchor";
import { fetchTilesetJson, findTilesForRegion, latLongToECEF } from "./googleMaps";
import { chunkProcess } from "./ioUtils";
import { transferToBlob } from "./transferToBlob";
import { saveRecord } from "../api/connection";
import JSZip from "jszip";
import { deleteOrgBlob, uploadOrgBlob } from "../panels/common/UploadBlob";
import { OrgBlobType } from "../models/OrgBlob";
import { SiteAnchorVisual } from "../visuals/SiteAnchorVisual";

export async function generateTiles(site: SiteAnchorVisual, setProgress: React.Dispatch<React.SetStateAction<number>>, setLoading?: React.Dispatch<React.SetStateAction<boolean>>) {
  if (setLoading) setLoading(true);

  console.log('Generating tiles for site:', site);
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY!;
  const tilesetJson = await fetchTilesetJson(apiKey);
  console.log('tilesetJson:', tilesetJson);

  const latLng = toPoint(site.mgrs);
  const point = latLongToECEF(latLng[1], latLng[0], site.location.alt);

  console.log('point:', point);

  const tiles = await findTilesForRegion(tilesetJson, point, site.grid.size, 'https://tile.googleapis.com', apiKey);
  console.log('tiles:', tiles);

  const tilesWithoutChildren = tiles.filter(tile => !tile.children);
  console.log('tilesWithoutChildren:', tilesWithoutChildren.length);

  setProgress(1);
  // await chunkProcess(tilesWithoutChildren, 10, async (tile) => {
  //   const index = tilesWithoutChildren.indexOf(tile);
  //   await transferToBlob(tile.contentUrl, `techmage-tiles`, `${site._id}_${index}.glb`);
  //   if (index % 10 === 0) {
  //     console.log('Transferred', index, 'tiles');

  //   }
  //   setProgress(1 + (index / tilesWithoutChildren.length) * 99);
  // });

  const zip = new JSZip();
  const tileMap: { [contentUrl: string]: string } = {};

  await chunkProcess(tilesWithoutChildren, 10, async (tile) => {
    const index = tilesWithoutChildren.indexOf(tile);
    const fileName = `${site._id}_${index}.glb`;

    const response = await fetch(tile.contentUrl);
    if (!response.ok) {
      console.error(`Failed to fetch tile: ${tile.contentUrl}: ${response.statusText}`);
      return;
    }
    const arrayBuffer = await response.arrayBuffer();
    zip.file(fileName, arrayBuffer);
    tileMap[tile.contentUrl] = fileName;
    if (index % 10 === 0) {
      console.log('Zipped', index, 'tiles');
    }
    setProgress(1 + (index / tilesWithoutChildren.length) * 99);
  });
  console.log('tileMap:', tileMap);
  const zipBlob = await zip.generateAsync({ type: 'arraybuffer' });
  console.log('Generated zip blob:', zipBlob);
  const uploadRes = await uploadOrgBlob(OrgBlobType.Tiles, zipBlob, 'techmage-tiles');
  console.log('Uploaded zip blob, result:', uploadRes);
  site.tileBlobId = uploadRes._id;
  await site.save();
  if (setLoading) setLoading(false);
  return;
}
